export { default as PendenciasModal } from './PendenciasCobrancaModal';
